import formHelperTextClasses from "@mui/material/FormHelperText/formHelperTextClasses";
import { textFieldLabelResponsive } from "../../styles/utils/textfield.module";
export const MuiFormHelperTextTheme = (dt) => {
    return {
        styleOverrides: {
            root: Object.assign(Object.assign({}, textFieldLabelResponsive(dt, ["inputHelper"])), { margin: 0, color: dt.color.onSurface.variant, display: "inline-flex", alignItems: "flex-start", ".PixelIcon": {
                    marginRight: "0.2em",
                }, ".MuiInputBase-colorSuccess ~ &": {
                    color: dt.cta.outlined.color.text.signal.success.default,
                }, [`&.${formHelperTextClasses.disabled}`]: {
                    color: dt.cta.outlined.color.text.primary.disabled,
                } }),
        },
    };
};
